import { ParteEnvolvida } from '../../modules/types/Aquisicao';
import httpClient from '../httpClient';
export async function getAllPartesEnvolvidasPorEntidade(
  tab: string,
  id: number,
) {
  try {
    const response = await httpClient.get(`/api/parteenvolvida/porentidade`, {
      params: {
        tab,
        id,
      },
    });
    return Array.isArray(response.data.registros)
      ? response.data.registros
      : [];
  } catch (error) {
    throw new Error('Erro ao obter lista de Registros: ' + error);
  }
}

export async function getPartesEnvolvidasByInstrumentoId(
  instrumentoId: number,
): Promise<ParteEnvolvida[]> {
  try {
    const response = await httpClient.get(`/api/parteenvolvida`, {
      params: {
        instrumentoId: instrumentoId,
      },
    });

    return Array.isArray(response.data.registros)
      ? response.data.registros
      : [];
  } catch (error) {
    throw new Error('Erro ao obter lista de Partes Envolvidas: ' + error);
  }
}

export async function handleCreateParteEnvolvida(
  form: ParteEnvolvida,
  tab: string,
) {
  try {
    return await httpClient.post(`/api/parteenvolvida?tab=${tab}`, form);
  } catch (error) {
    throw error;
  }
}

export async function handleUpdateParteEnvolvida(form: ParteEnvolvida) {
  try {
    const response = await httpClient.patch(
      `/api/parteenvolvida/${form.id}`,
      form,
    );

    return response;
  } catch (error) {
    throw error;
  }
}

export async function handleDeleteParteEnvolvida(id: string | number) {
  try {
    return await httpClient.delete(`/api/parteenvolvida/${id}`);
  } catch (error) {
    throw error;
  }
}
